import React, { useState, useEffect, useContext } from "react";
import { Navigate } from 'react-router-dom';
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { makeStyles } from "@mui/styles";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import styled from "styled-components";
import UserService from "services/UserService";
import { getActionPlan, deleteAction } from "services/ConfigServices";
import { ActionPlansContext } from "context/ActionPlansContext";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { statusData, categoryData } from "variables/lists/action";
import CustomDeleteDialog from "components/CustomDeleteDialog/CustomDeleteDialog.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import CustomCommentDialog from "components/CustomCommentDialog/CustomCommentDialog.js";
import SelectedActions from "./SelectedActions.js";
import useActionTable from "./useActionTable.js";
//import "react-table/react-table.css";

// @mui/icons-material
import GetAppIcon from "@mui/icons-material/GetApp";

import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const RTActions = ({ planActionId, planActionName }) => {
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = advancedSearchContext;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplancreate = permis.includes("actionplan_create");
  const { gridState, refreshTable } = useActionTable();
  const appContext = useContext(ActionPlansContext);
  const { actionPlans, setActionPlans } = appContext;

  const [redirState, setRedirState] = useState(false);
  const [actionId, setActionId] = useState("");
  const [actionName, setActionName] = useState("");
  let redirecting = redirState ? (
    <Navigate
      push
      to={{
        pathname: "/admin/actionplans/selectedplanaction/selectedaction/",
        state: {
          planActionId,
          planActionName,
          actionId,
          actionName,
          groupParent: actionPlans.parameters.general.groups,
          actionPlansParameters: actionPlans.parameters,
        },
      }}
      state= {{
        planActionId,
        planActionName,
        actionId,
        actionName,
        groupParent: actionPlans.parameters.general.groups,
        actionPlansParameters: actionPlans.parameters,
      }}
    />
  ) : (
    ""
  );

  let dataActions = actionPlans.actions;

  const classes = useStyles();

  // console.log(dataActions);
  // console.log(gridState.data);

  // if (error) {
  //   return (
  //     <p>
  //       <span role="img" aria-label="Problem">
  //         🔧
  //       </span>{" "}
  //       Oups il semble y avoir un problème...{" "}
  //       <button onClick={refetch}>Réesayer</button>
  //     </p>
  //   );
  // }

  const columns = [
    {
      name: "Nom",
      selector: (row) => row.parameters.name,
      sortable: true,
    },
    {
      name: "Catégorie",
      selector: (row) => row.parameters.category,
      sortable: true,
      cell: (row) => row.parameters.category ? categoryData.find((x) => x.id == row.parameters.category).name || "" : ""
    },
    {
      name: "Dernière mise à jour",
      sortable: true,
      maxWidth: "7rem",
      cell: (row) =>
        row.parameters.lastupdate && moment(row.parameters.lastupdate).isValid() ? (
          moment(row.parameters.lastupdate).format("DD/MM/YYYY")
        ) : (
          <div></div>
        ),
    },
    {
      name: "Date de début prévue",
      sortable: true,
      maxWidth: "7rem",
      cell: (row) =>
        row.parameters.wantedstartdate && moment(row.parameters.wantedstartdate).isValid() ? (
          moment(row.parameters.wantedstartdate).format("DD/MM/YYYY")
        ) : (
          <div></div>
        ),
    },
    {
      name: "Date de fin prévue",
      sortable: true,
      maxWidth: "7rem",
      cell: (row) =>
        row.parameters.wantedenddate && moment(row.parameters.wantedenddate).isValid() ? (
          moment(row.parameters.wantedenddate).format("DD/MM/YYYY")
        ) : (
          <div></div>
        ),
    },

    {
      name: "Criticité",
      sortable: true,
      cell: (row) =>
        row.parameters.criticity == "weak" ? (
          <div
            style={{
              color: "#008083",
              fontWeight: "bold",
              backgroundColor: "rgba(0,128,131,0.2)",
              borderRadius: "6px",
              padding: "0.25rem 0.6rem",
            }}
          >
            Faible
          </div>
        ) : row.parameters.criticity == "medium" ? (
          <div
            style={{
              color: "#E3A322",
              fontWeight: "bold",
              backgroundColor: "rgba(227,163,34,0.2)",
              borderRadius: "6px",
              padding: "0.25rem 0.6rem",
            }}
          >
            Moyen
          </div>
        ) : row.parameters.criticity == "important" ? (
          <div
            style={{
              color: "#FF8E55",
              fontWeight: "bold",
              backgroundColor: "rgba(255,142,85,0.2)",
              borderRadius: "6px",
              padding: "0.25rem 0.6rem",
            }}
          >
            Important
          </div>
        ) : row.parameters.criticity == "critical" ? (
          <div
            style={{
              color: "#FF432D",
              fontWeight: "bold",
              backgroundColor: "rgba(255,67,45,0.2)",
              borderRadius: "6px",
              padding: "0.25rem 0.6rem",
            }}
          >
            Critique
          </div>
        ) : (
          <div></div>
        ),
    },
    {
      name: "Statut",
      sortable: true,
      cell: (row) =>
        row.parameters.status == "creation" ? (
          <div style={{ color: "#849191", fontWeight: "bold" }}>
            {statusData.find((x) => x.id == "creation").name}
          </div>
        ) : row.parameters.status == "pending" ? (
          <div style={{ color: "#E3A322", fontWeight: "bold" }}>
            {statusData.find((x) => x.id == "pending").name}
          </div>
        ) : row.parameters.status == "inprogress" ? (
          <div style={{ color: "#008083", fontWeight: "bold" }}>
            {statusData.find((x) => x.id == "inprogress").name}
          </div>
        ) : row.parameters.status == "standby" ? (
          <div style={{ color: "#FF8E55", fontWeight: "bold" }}>
            {statusData.find((x) => x.id == "standby").name}
          </div>
        ) : row.parameters.status == "finished" ? (
          <div style={{ color: "#91C73C", fontWeight: "bold" }}>
            {statusData.find((x) => x.id == "finished").name}
          </div>
        ) : (
          <div style={{ color: "#FF432D", fontWeight: "bold" }}></div>
        ),
    },
    {
      name: "Périmètre",
      selector: (row) => row.parameters.groups,
      sortable: true,
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <GroupCell>
          <div>{groupInfoListById["" + row.parameters.groups]}</div>
        </GroupCell>
      ),
    },
    {
      name: "",
      sortable: false,
      width: "7rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Voir les détails de l'action">
              <Button
                onClick={actionDetail(row)}
                color={"info"}
                className={classes.actionButton}
              >
                <VisibilityIcon fontSize="large" />
              </Button>
            </Tooltip>
            {actionplancreate && (
              <CustomDeleteButton
                deleteTitle={"Suppression d'action"}
                deleteSubTitle={`Êtes-vous sûr de vouloir supprimer l'action ${row.parameters.name} ?`}
                handleSupprimer={deleteActionSelected(row)}
              />
            )}
          </div>
        </>
      ),
    },
  ];

  const deleteActionSelected = (row) => async () => {
    let obj = dataActions.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = deleteAction(idSelected);
    axios
      .delete(url, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200)
          NotificationManager.success(
            `L'action ${row.parameters.name} a bien été supprimé`
          );
        else NotificationManager.error("Un problème est survenu");
      });

    axios
      .get(getActionPlan(planActionId), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        setActionPlans(response.data || []);
        refreshTable();
      });
  };

  const actionDetail = (row) => async () => {
    setActionId(row.id);
    setActionName(row.parameters.name);
    setRedirState(true);
  };
  return (
    <GridContainer>
      <GridItem xs={12}>
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          noHeader={true}
          columns={columns}
          persistTableHead
          pagination
          subHeader
          progressPending={gridState.loading}
          progressComponent={<LinearProgress />}
          highlightOnHover
          pointerOnHover
          onRowClicked={(row) => {
            setActionId(row.id);
            setActionName(row.parameters.name);
            setRedirState(true);
          }}
          //dense
          paginationComponentOptions={{
            noRowsPerPage: false,
            rowsPerPageText: "Actions par page",
            rangeSeparatorText: "sur",
            selectAllRowsItem: false,
            selectAllRowsItemText: "Selectionner toutes les actions",
          }}
          {...gridState}
        />
        {redirecting}
      </GridItem>
    </GridContainer>
  );
};

export default RTActions;
